import { render, staticRenderFns } from "./pricing-compare-mobile.vue?vue&type=template&id=c7278ace&scoped=true&"
import script from "./pricing-compare-mobile.vue?vue&type=script&lang=js&"
export * from "./pricing-compare-mobile.vue?vue&type=script&lang=js&"
import style0 from "./pricing-compare-mobile.vue?vue&type=style&index=0&id=c7278ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7278ace",
  null
  
)

export default component.exports